import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { VStack } from '@/components/Layout';
import { Loader } from '@/components/Loading';

import { MyProfileHeader } from './-components/MyProfileHeader';

export const Route = createFileRoute(
  '/_individual/individual/_profile/my-profile/_layout',
)({
  component: MyProfileLayout,
});

function MyProfileLayout() {
  return (
    <VStack className="md:h-full">
      <Suspense fallback={<HeaderSkeleton />}>
        <MyProfileHeader />
      </Suspense>
      <Outlet />
    </VStack>
  );
}

function HeaderSkeleton() {
  return (
    <div className="border-b border-neutral-muted-border">
      <VStack className="bg-neutral-fill px-6 lg:px-12 py-6 shadow-sm gap-4 items-center justify-center h-32">
        <Loader />
      </VStack>
    </div>
  );
}
